

exports.__esModule = true;

var _angular = require('angular');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./styles');

require('components/jquery-mask-plugin/dist/jquery.mask.min');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var MOBILE = 'Mobile';
var KEYS = {
    ENTER: 13,
    UP: 38,
    DOWN: 40,
    TAB: 9,
    ESC: 27,
    A: 65,
    Z: 90,
    SPACE: 32
};

var query = '';
var queryTimer = null;

exports['default'] = _squid.$Component.extend('$xoPhoneInputB', {
    tag: 'xo-phone-input-b',
    template: _template2['default'],

    props: {
        phone: {
            type: 'var',
            optional: false
        },

        hidePhoneType: {
            type: 'var',
            optional: true
        },

        hideWork: {
            type: 'var',
            optional: true,
            'default': false
        }
    },

    actions: {

        // return the phonePattern
        getPhonePattern: function getPhonePattern(phoneEntry) {
            var DEFAULT_PATTERN = '^[0-9]+$';
            var patterns = phoneEntry && phoneEntry.patterns;
            // less strict regex validation in place for now, just use general regex to match mobile AND fixed-line
            // formats
            // for now we use less strict regex validation because we are not ready for this more strict validation
            return patterns && patterns.GENERAL ? patterns.GENERAL : DEFAULT_PATTERN;
        },


        // return phoneMask based on phone Type
        getPhoneMask: function getPhoneMask(phoneType, phoneEntry) {
            var DEFAULT_MASK = '0000000000000000';
            var masks = phoneEntry && phoneEntry.masks;

            if (phoneType === MOBILE) {
                return masks && masks.MOBILE ? masks.MOBILE : DEFAULT_MASK;
            } else {
                return masks && masks.FIXED_LINE ? masks.FIXED_LINE : DEFAULT_MASK;
            }
        },


        // set the phone number mask and pattern
        updatePhoneMaskAndPattern: function updatePhoneMaskAndPattern() {
            var phoneEntry = this.metadata.phoneEntry;
            this.mask = this.actions.getPhoneMask(this.phone.phoneType, phoneEntry);
            this.pattern = this.actions.getPhonePattern(phoneEntry);
            this.actions.applyMaskOnPhoneInput();
        },


        // fetch the passed country's international dialing code
        updateDialingCodeAndCountry: function updateDialingCodeAndCountry(territory) {
            this.phoneCountry = territory.code;
            this.phone.IntDialingCountryCode = territory.internationalDialingCode;
            (0, _jquery2['default'])('.fixedCode').text('+' + this.phone.IntDialingCountryCode);
        },


        /* if user chooses a different dialing code -
         -. fetch the new country's metadata
         -. update phone Country and dialing code
         -. update the phone number mask and pattern (no explicit call as it happens when metadata updates)
         -. close the dropdown if open
         */
        updatePhoneFieldMetadata: function updatePhoneFieldMetadata(territory) {

            // create a local copy of metadata (only happens on initial load)
            if (!this.metadata) {
                this.metadata = _squid.$MetadataModel.instance(0, {
                    'noBroadcast': true
                });
            }
            this.metadata.choose(territory.code);

            this.actions.updateDialingCodeAndCountry(territory);
            // Whenever metadata is updated that is promise returns then the metadata listener will update the mask
            // and pattern so not calling it here. Moving on...

            // close the dropdown if open
            if (this.listVisible) {
                this.actions.collapseListAndFocusOnParent();
            }

            _logger.$logger.info('phone_country_code_updated', {
                territory: territory.code
            });
        },
        getTerritoryDataFromMetadata: function getTerritoryDataFromMetadata(country) {

            var territory = _squid.$util.find(this.dialingCodeList, function (obj) {
                return obj.code === country;
            });

            return territory;
        },


        // set the stage on first load or on locale change
        init: function init(country) {

            this.hidePhoneType = this.hidePhoneType || (0, _squid.$feature)('hidePhoneType', false, country);

            this.showDialingCodeContainer = (0, _squid.$feature)('showDialingCodeContainer', false, country);

            this.listVisible = false;

            // default the phone type to Mobile if not specified
            // Note: this.phone is not optional
            this.phone = this.phone || {};

            this.phone.phoneType = this.phone.phoneType || 'Mobile';

            // populate the dialing code list/options
            this.dialingCodeList = _squid.$locale.metadata.territory;

            var territory = this.actions.getTerritoryDataFromMetadata(this.phone.phoneCountry || country);

            this.actions.updatePhoneFieldMetadata(territory);
        },


        // helper to show the options list and focus on the selected phone country option
        expandList: function expandList() {
            (0, _jquery2['default'])('.country-list').show();
            this.listVisible = true;
            (0, _jquery2['default'])('.country-list .country.selected').focus();
        },


        // helper to collapse the options
        collapseList: function collapseList() {
            this.listVisible = false;
            (0, _jquery2['default'])('.country-list').hide();
        },


        // helper to collapse the options and xfer focus back to the parent dropdown
        collapseListAndFocusOnParent: function collapseListAndFocusOnParent() {
            this.actions.collapseList();
            (0, _jquery2['default'])('#dialingCodeContainer div.selected-flag').focus();
        },


        // helper to toggle the dropdown list
        toggleList: function toggleList() {
            if (this.listVisible) {
                this.actions.collapseListAndFocusOnParent();
            } else {
                this.actions.expandList();
            }
        },


        // remove highlighting from other list items and highlight the given item
        highlightListItem: function highlightListItem(listItem) {
            (0, _jquery2['default'])('li.country').removeClass('highlight');
            listItem.addClass('highlight');
            listItem.focus();
        },

        // select the given item and update the phone field metadata
        selectListItem: function selectListItem(listItem) {
            var country = listItem.attr('data-country-code');
            var territory = this.actions.getTerritoryDataFromMetadata(country);

            this.actions.updatePhoneFieldMetadata(territory);
        },

        // find the first list item whose name starts with the query string
        searchForCountry: function searchForCountry(queryString) {
            for (var i = 0; i < this.dialingCodeList.length; i++) {
                if (this.actions.startsWith(this.dialingCodeList[i].name, queryString)) {

                    var listItem = (0, _jquery2['default'])('.country-list').find('[data-country-code="' + this.dialingCodeList[i].code + '"]');
                    // update highlighting and scroll
                    this.actions.highlightListItem(listItem);
                    break;
                }
            }
        },

        // check if (uppercase) string a starts with string b
        startsWith: function startsWith(a, b) {
            return a.substr(0, b.length).toUpperCase() === b;
        },

        // format the phone number
        applyMaskOnPhoneInput: function applyMaskOnPhoneInput() {
            this.$element.find('.telephone').mask(this.mask, {
                'translation': {
                    0: { pattern: /[0-9]/ }
                }
            });
        },

        // highlight the event target
        handleListMouseover: function handleListMouseover($event) {
            this.actions.highlightListItem((0, _jquery2['default'])($event.target));
        },

        // expand the list when down arrow is pressed
        handleKeyboardInputForDropdown: function handleKeyboardInputForDropdown($event) {

            var key = $event.which;
            if (key === KEYS.DOWN || key === KEYS.UP || key === KEYS.SPACE) {
                $event.stopPropagation();
                $event.preventDefault();
                this.actions.expandList();
            } else {
                this.actions.collapseList();
            }
        },

        /*
         navigating list using the keyboard
         up, down, esc, enter and letter keys
         */
        handleKeyboardInputForList: function handleKeyboardInputForList($event) {
            var $listItems = (0, _jquery2['default'])('li.country');
            var key = $event.which;
            var $selected = (0, _jquery2['default'])($event.target);
            var $current = void 0;

            $event.stopPropagation();
            $event.preventDefault();

            // if user types in an input, focus on the first country starting with that query
            // upper case letters (since keyup/keydown only return upper case letters)
            if (key >= KEYS.A && key <= KEYS.Z) {
                if (queryTimer) {
                    _angular.$timeout.cancel(queryTimer);
                }

                query += String.fromCharCode(key);
                this.actions.searchForCountry(query);

                queryTimer = (0, _angular.$timeout)(function () {
                    query = '';
                }, 1e3);

                return;
            }

            // ignore other keys
            if (key !== KEYS.DOWN && key !== KEYS.UP && key !== KEYS.ENTER && key !== KEYS.ESC) {
                return;
            }

            // select the the new phone country when user hits enter
            if (key === KEYS.ENTER) {
                this.actions.selectListItem($selected);
                return;
            }

            // close the list if escape is pressed
            if (key === KEYS.ESC) {
                this.actions.collapseListAndFocusOnParent();
                return;
            }

            // highlight the next/prev element when arrow key is pressed
            if (key === KEYS.DOWN) // Down key
                {
                    if (!$selected.length || $selected.is(':last-child')) {
                        $current = $listItems.eq(0);
                    } else {
                        $current = $selected.next();
                    }
                }

            // Up key
            if (key === KEYS.UP) {
                if (!$selected.length || $selected.is(':first-child')) {
                    $current = $listItems.last();
                } else {
                    $current = $selected.prev();
                }
            }

            this.actions.highlightListItem($current);
        }
    },

    lifecycle: {
        enter: function enter() {
            this.actions.init(_squid.$locale.country);
        },
        populate: function populate() {
            var _this = this;

            _angular.$rootScope.$on('localeChange', function () {
                _this.actions.init(_squid.$locale.country);
            });

            // update the phone mask and pattern when metadata is changed
            this.$watch('metadata', function () {
                _this.actions.updatePhoneMaskAndPattern();
            }, true);

            // update the mask when .telephone val changes either programatically or via user action
            this.$watch('this.phone.telephone', function (newVal) {
                if (newVal) {
                    _this.$element.find('.telephone').val(newVal).trigger('input');
                }
            }, true);

            // hide the dropdown list if a click occurs anywhere else on the page
            (0, _jquery2['default'])('*').on('click', function (event) {
                if (!(0, _jquery2['default'])('#dialingCodeContainer div.selected-flag').is((0, _jquery2['default'])(event.target))) {
                    _this.actions.collapseList();
                }
            });
        }
    }
});


_angular.$rootScope;

_angular.$timeout;

_squid.$Component;

_squid.$locale;

_squid.$feature;

_squid.$util;

_squid.$MetadataModel;

_logger.$logger;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-form-components/src/phone/phoneInputB/directive.js
// module id = ./components/xo-form-components/src/phone/phoneInputB/directive.js
// module chunks = 1